import { isString } from "../../validate"
import { isInputText } from "./specialChecking"

export default ({ value: str }) => {
  if (!isString(str)) return false

  const maxAddressLineLength = 60
  if (str.length <= 0 || str.length > maxAddressLineLength) return false

  return isInputText(str)
}
